export const QuizData = [
    {
        question: "Which language runs in a web browser?",
        options: ["Java", "C", "Python", "JavaScript"],
        answer: 4
    },
    {
        question: "What does CSS stand for?",
        options: ["Central Style Sheets", "Cascading Style Sheets", "Cascading Simple Sheets", "Cars SUVs Sailboats"],
        answer: 2
    },
    {
        question: "What does HTML stand for?",
        options: ["Hypertext Markup Language", "Hypertext Markdown Language", "Hyperloop Machine Language", "Helicopters Terminals Motorboats Lamborginis"],
        answer: 1
    },
    {
        question: "What year was JavaScript launched?",
        options: ["1996", "1995", "1994", "none of the above"],
        answer: 2
    },
    // New Questions
    {
        question: "Which of the following is a JavaScript framework?",
        options: ["React", "Laravel", "Django", "Flask"],
        answer: 1
    },
    {
        question: "What does the 'DOM' stand for in web development?",
        options: ["Document Object Model", "Data Object Model", "Document Online Model", "Dynamic Object Model"],
        answer: 1
    },
    {
        question: "Which HTML tag is used to define an internal style sheet?",
        options: ["<style>", "<script>", "<css>", "<link>"],
        answer: 1
    },
    {
        question: "What is the purpose of the 'alt' attribute in an image tag?",
        options: ["To define alternative text for an image", "To set the image size", "To add a link to the image", "To set image border color"],
        answer: 1
    },
    {
        question: "Which method is used to create a new array instance in JavaScript?",
        options: ["Array.new()", "new Array()", "Array.create()", "Array.make()"],
        answer: 2
    },
    {
        question: "In CSS, which property is used to change the text color?",
        options: ["color", "font-color", "text-color", "background-color"],
        answer: 1
    }
];
